import { Helmet } from 'react-helmet-async';
import { useGetUsers } from 'src/api/user';
import { LoadingScreen } from 'src/components/loading-screen';
import SalesMapView from 'src/sections/sales-map/view/sales-map-view';
// sections
import { UserListView } from 'src/sections/user/view';


// ----------------------------------------------------------------------

export default function SalesMapListPage() {

  return (
    <>
      <Helmet>
        <title>Sales Map - LMS</title>
      </Helmet>

      <SalesMapView />
      {/* {usersLoading ? <LoadingScreen /> : <UserListView users={users} />} */}
      {/* <UserListView users={GET_USER_LIST} /> */}
    </>
  );
}
